import { render, staticRenderFns } from "./SubscriptionsActiveTable.vue?vue&type=template&id=0893c689&scoped=true&"
import script from "./SubscriptionsActiveTable.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsActiveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893c689",
  null
  
)

export default component.exports